export default __webpack_public_path__ + "static/media/ibnsalman.1cc6a5d1.jpg";